import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function InviteUser({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Invite User'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

